/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_File_NameInputs */

const en_why_listening_insights_file_name = /** @type {(inputs: Why_Listening_Insights_File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep spindles and memory.pdf`)
};

const es_why_listening_insights_file_name = /** @type {(inputs: Why_Listening_Insights_File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Husos del sueño y memoria.pdf`)
};

/**
* | output |
* | --- |
* | "Sleep spindles and memory.pdf" |
*
* @param {Why_Listening_Insights_File_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_file_name = /** @type {((inputs?: Why_Listening_Insights_File_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_File_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_file_name(inputs)
	return en_why_listening_insights_file_name(inputs)
});